import { setFocusOnField } from '@/core/core_components/form/form'
import { bindResetButtonModal } from '@/core/input_controls/button/button'
import { getLocalizedMessage, showMessageAlert } from '@/core/shared'
import { initDataInTextInput } from '@/core/item_assistance/initializeComponentData'

export function TagsManager (global) {
	'use strict'

	this.global = global
	this.companyId = undefined

	this.tag = {}
	this.fields = undefined

	this.action = undefined
	this.activeAttribute = undefined
	this.saveButton = undefined
	this.postSaveAction = undefined
	this.prefix = undefined

	this.setProperties = function (properties) {
		this.action = properties.action || 'create'
		this.tag = properties.tag || undefined
		this.activeAttribute = properties.activeAttribute || undefined
		this.prefix = properties.prefix || 'tag_'
		this.saveButton = properties.saveButton || '#sidebar_save'
		this.postSaveAction = properties.postSaveAction
		this.companyId = properties.companyId
		this.fields = properties.fields || ['name']
	}

	this.initPage = function () {
		this.resetFields()

		if (this.action == 'edit') {
			this.setTagInformation()
			setFocusOnField(this.activeAttribute)
		}

		attachEvents(this)
		bindResetButtonModal()
	}

	this.initTagsManager = function (action) {
		var manager = this
		Swal.fire({
			title: getLocalizedMessage('tags'),
			html: '<div class="modal_item">\n' +
				'    <label for="tag_name">' + getLocalizedMessage('name') + '</label>\n' +
				'    <br>\n' +
				'    <input id="tag_name" class="textInput attribute-editor" type="text">\n' +
				'    <button class="button_reset fa fa-times"></button>\n' +
				'</div>',
			confirmButtonText: getLocalizedMessage('save'),
			showCancelButton: true,
			cancelButtonText: getLocalizedMessage('cancel'),
			buttonsStyling: false,
			allowOutsideClick: false,
			allowEnterKey: true,
			showClass: {
				popup: ''
			},
			hideClass: {
				popup: ''
			},
			customClass: {
				content: 'form',
				confirmButton: 'uk-button uk-button-primary uk-button-small uk-margin-small-right',
				cancelButton: 'uk-button uk-button-default uk-button-small',
			},
			onRender: function () {
				manager.initPage()
			},
			preConfirm: function (inputValue) {
				var tagInformationField = manager.getTagInformation()
				return tagInformationField
			}
		}).then(function (result) {
			if (result.value) {
				manager.saveTag(action, result.value)
			}
		})
	}

	this.resetFields = function () {
		var manager = this
		_.each(this.fields, function (field) {
			$('#' + manager.prefix + field).val('')
		})
	}

	this.setTagInformation = function () {
		var manager = this
		_.each(this.tag, function (value, key) {
			initDataInTextInput(manager.prefix + key, value)
		})
	}

	function attachEvents (manager) {
		$(manager.saveButton).unbind('click')
		$(manager.saveButton).click(function () {
			manager.saveTag()
		})
	}

	this.updateTagsTable = function (table) {
		var prefix = this.global ? 'global/' : 'company/'
		$.ajax({
			type: 'GET',
			url: window.urlContext + prefix + 'tags',
			success: function (data) {
				table.updateData(data)
			}
		})
	}

	this.deleteTag = function (tag, table) {
		var manager = this
		var prefix = manager.global ? 'global/' : 'company/'

		Swal.fire({
			title: getLocalizedMessage('delete') + ' ' + tag['name'] + '?',
			allowOutsideClick: true,
			confirmButtonText: getLocalizedMessage('ok'),
			showCancelButton: true,
			cancelButtonText: getLocalizedMessage('cancel'),
			buttonsStyling: false,
			allowEnterKey: true,
			showClass: {
				popup: ''
			},
			hideClass: {
				popup: ''
			},
			customClass: {
				confirmButton: 'uk-button uk-button-primary uk-button-small uk-margin-small-right',
				cancelButton: 'uk-button uk-button-default uk-button-small',
			}
		}).then(function (result) {
			if (result.value) {
				$.ajax({
					type: 'POST',
					url: window.urlContext + prefix + 'tags/delete',
					data: { id: tag['id'] },
					async: false,
					success: function () {
						table.initTable()
						showMessageAlert(getLocalizedMessage('remove.tags.message'), 'success')
					},
					error: function (response) {
						if (response.status === 409) {
							showMessageAlert(getLocalizedMessage('unresolved.references.exist'), 'danger')
						} else {
							showMessageAlert(getLocalizedMessage('error'), 'danger')
						}
					}
				})
			}
		})
	}

	this.saveTag = function (action, tagInformation) {
		var manager = this
		var prefix = manager.global ? 'global/' : 'company/'
		var actionUrl = manager.action === 'edit' ? 'tags/update' : 'tags/create'
		var url = prefix + actionUrl
		$.ajax({
			url: window.urlContext + url,
			type: 'POST',
			data: JSON.stringify(tagInformation),
			contentType: 'application/json; charset=UTF-8',

			success: function () {
				if (manager.postSaveAction) {
					manager.postSaveAction()
				}
				showMessageAlert(getLocalizedMessage('changes.saved'), 'success')
			},
			error: function () {
				showMessageAlert(getLocalizedMessage('error.saving'), 'danger')
			}
		})
	}

	this.getTagInformation = function () {
		var manager = this

		var tagInformation = {}
		if (manager.action == 'edit') {
			tagInformation['id'] = this.tag.id
		}
		if (!manager.global) {
			tagInformation['companyId'] = this.companyId
		}

		_.each(this.fields, function (field) {
			var $field = $('#' + manager.prefix + field)
			tagInformation[field] = $field.val()
		})
		return tagInformation;
	};
}
